module.exports = __webpack_public_path__ + "static/media/bronze.f98243fd.svg";